import { Mail } from "lucide-react";
import TopNav from "@/components/TopNav";

export default function Contact() {
  return (
    <div className="min-h-screen">
      <TopNav />
      <main className="max-w-3xl mx-auto px-4 sm:px-8 pt-16 pb-24">
        <span className="pill text-[11px] tracking-[0.2em] px-4 py-1.5 glass text-teal-accent inline-block">SUPPORT</span>
        <h1 className="serif text-4xl sm:text-5xl font-extrabold mt-5">Contact us</h1>
        <div className="glass-strong rounded-3xl p-10 mt-8 text-center">
          <div className="w-16 h-16 rounded-2xl bg-[#00D4D4]/12 flex items-center justify-center mx-auto mb-5">
            <Mail size={28} className="text-teal-accent" />
          </div>
          <p className="text-muted-foreground mb-2">Need help? Reach our support team by email:</p>
          <a data-testid="contact-email" href="mailto:support@kiqtechno.com"
             className="serif text-2xl sm:text-3xl font-bold text-teal-accent glow-text break-all">support@kiqtechno.com</a>
          <p className="text-sm text-muted-foreground mt-5">Simply send us a mail and we'll get back to you.</p>
        </div>
      </main>
    </div>
  );
}
